import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import './AboutUs.css';

const teamMembers = [
    {
      name: "Jyh-Chung Han",
      title: "Co-Founder",
      image: "/jj_new.png",
      shortBio: "Strategic vision and growth leader with international business expertise ",
      useTabs: true,
      tabs: {
        overview: [
          "Jyh-Chung Han graduated from the National Taipei University of Technology with a BA in Civil Engineering. Since then, he has gained extensive business experience in real estate, construction, company management, and company operations within the Koo Organization.",
          "In the past 30 years, he has successfully established and operated many oversea corporations for the Koo family including, but not limited to, managing resorts, hotels, medical facilities, and transportation. His counsel has been widely sought in these various fields.",
          "Mr. Han co-founded Newport Brain Research Laboratory (NBRL), Brain Treatment Center (BTC), and helped create the MRT and MeRT technologies currently used by WaveNeuroscience, Inc."
        ]
      }
    },
    {
      name: "Conway Ho",
      title: "Co-Founder",
      image: "/ho2.png",
      shortBio: "Serial entrepreneur, co-founded the foundational research laboratory and treatment centers",
      useTabs: true,
      tabs: {
        overview: [
          "Conway is a successful businessman and entrepreneur. He began creating a video game and entertainment business while in college, establishing a successful enterprise that included a software development studio.",
          "As the Co-Founder of HanaHo Games and many others, his companies have worked under contract with Microsoft, Capcom, Electronic Arts, Sega, Konami, and Namco, to name a few. During this time, he also owned the North American Licenses to Street Fighter and Space Invaders, two of the most well-known video games to date, as well as hundreds of other electronic games.",
          "Now, Conway brings his entrepreneurial skills to NoetherTech focusing on research and treatment of neurological and psychiatric disorders. In medicinal research, Conway has assembled and spearheaded medical technology teams to conduct research and develop treatments.",
          "Conway co-founded Newport Brain Research Laboratory (NBRL), Brain Treatment Center (BTC), and created the MRT and MeRT technologies currently used by WaveNeuroscience, Inc."
        ]
      }
    },
    {
      name: "Yi Jin, M.D.",
      title: "Chief Technology Officer",
      image: "/jin2.png",
      shortBio: "Pioneer in brain-wave-guided transcranial magnetic stimulation",
      useTabs: true,
      tabs: {
        overview: [
          "Dr. Yi Jin graduated medical school at Shanghai First Medical College, completed his postdoctoral fellowships at the University of California, Los Angeles School of Medicine's Neuropsychiatric Institute and University of California, Irvine Medical Center's Department of Psychiatry and Human Behavior, and practiced as a clinical psychiatrist until 1986. In the past 25 years, he has taught and researched at the University of California, Irvine, and University of California, San Diego.",
          
          "His main academic interests are the neuro-physical process in normal and abnormal cognition. Using various types of sensory stimulations and neural imaging recording, he has found that the brain's cognitive process is discrete and its accuracy depends on the internal rhythmic oscillation. The rhythmicity itself, however, is \"tunable\" via proper external stimulation. This discovery opens up a new avenue for treatment of mental disorders.",
          
          "During the past 13 years, he has studied the novel physical treatment, repetitive transcranial magnetic stimulation (TMS). Using individual's intrinsic brain wave frequency, he successfully treated many patients with various types of neuropsychiatric disorder, including schizophrenia, major depression, anxiety, substance abuse, and autism. Several results have been published in peer reviewed journals and presented at academic conferences. Dr. Jin was also previously a research scientist at both USC Neurorestoration Center and the Los Amigos Rehabilitation Center.",
          
          "In addition to the academic works at the University, he has cofounded two companies, NeoSync, Inc and Brain Treatment Center (BTC) since 2007. Neosync is a privately funded corporation manufacturing portable TMS instruments, and BTC, a psychiatric clinic using EEG and TMS to assist clinical diagnosis and treatment for autistic spectral disorder (ASD) and other mental disorders."
        ],
        Academics: [
          "Education:",
          "Shanghai First Medical College, MD, 1983",
          "Residencies: Shanghai Mental Hospital, Shanghai Medical University, 1983 - 1986",
          
          "Fellowships:",
          "UCLA School of Medicine, Neuropsychiatric Institute, 1986-1987",
          "Reise-David Child Center, Los Angeles, 1987",
          "UCI Medical Center, Department of Psychiatry and Human Behavior, 1987-1988",
          
          "Professional Society Memberships:",
          "Executive Board Member for the EEG & Clinical Neuroscience Society"
        ],
        research: [
          "His main academic interests are the neuro-physical processes in normal and abnormal cognition. Using various types of sensory stimulations and neural imaging recording, he has found that the brain's cognitive process is discrete and its accuracy depends on the internal rhythmic oscillation.",
          "Dr. Jin discovered that brain rhythmicity is \"tunable\" via proper external stimulation, opening up new avenues for treating mental disorders.",
          "During the past 13 years, he has studied repetitive transcranial magnetic stimulation (TMS) using individual's intrinsic brain wave frequency. This approach has successfully treated many patients with various types of neuropsychiatric disorder, including schizophrenia, major depression, anxiety, substance abuse, and autism.",
          "His clinical research has demonstrated significant improvements in patients with posttraumatic stress disorder through Magnetic Resonance Therapy, showing improvements in clinical phenotype and EEG alpha power."
        ],
        publicationsLinks: [
          { text: "Magnetic Resonance Therapy Improves Clinical Phenotype and EEG Alpha Power in Posttraumatic Stress Disorder. Trauma Mon. 2015 Nov;20(4):e27360.", url: "https://pubmed.ncbi.nlm.nih.gov/26839865/" },
          { text: "A pilot study of the use of EEG-based synchronized Transcranial Magnetic Stimulation (sTMS) for treatment of Major Depression. BMC Psychiatry. 2014 Jan 18;14:13.", url: "https://pubmed.ncbi.nlm.nih.gov/24438321/" },
          { text: "A randomized double-blinded sham-controlled trial of α electroencephalogram-guided transcranial magnetic stimulation for obsessive-compulsive disorder. Chin Med J (Engl). 2014;127(4):601-6.", url: "https://pubmed.ncbi.nlm.nih.gov/24534207/" },
          { text: "Alpha EEG guided TMS in schizophrenia. Brain Stimul. 2012 Oct;5(4):560-8.", url: "https://pubmed.ncbi.nlm.nih.gov/22019083/" },
          { text: "Therapeutic effects of individualized alpha frequency transcranial magnetic stimulation (alphaTMS) on the negative symptoms of schizophrenia. Schizophr Bull. 2006 Jul;32(3):556-61.", url: "https://pubmed.ncbi.nlm.nih.gov/16254067/" },
          { text: "Alpha EEG predicts visual reaction time. Int J Neurosci. 2006 Sep;116(9):1035-44.", url: "https://pubmed.ncbi.nlm.nih.gov/16861166/" },
          { text: "Abnormal EEG responses to photic stimulation in schizophrenic patients. Schizophr Bull. 1990;16(4):627-34.", url: "https://pubmed.ncbi.nlm.nih.gov/2077640/" }
        ],
        publications: [],
        awards: [
          "2002 Balter Award, Journal of Clinical Psychopharmacology",
          "1991 MRES Award for Pharmaco-EEG, University of California, Irvine"
        ]
      }
    }
  ];

const advisors = [
  {
    name: "Hyman M. Schipper, MD, PhD, FRCPC",
    title: "Scientific Advisor",
    image: "/schipper.jpg",
    shortBio: "Professor of Neurology and Medicine at McGill University and Senior Investigator at the Lady Davis Institute",
    useTabs: true,
    tabs: {
      overview: [
        "Dr. Schipper received his M.D. and Ph.D. (Neuroendocrinology) degrees at McGill University in 1982. He studied Internal Medicine at McGill University, Neurology at Columbia University, and Endocrinology at Tufts University. Dr. Schipper is currently tenured Professor of Neurology and Medicine (Geriatrics) at McGill, staff neurologist at the Jewish General Hospital, and consultant at other Montreal institutions. He is also the founding scientist of Molecular Biometrics Inc.",
        "Dr. Schipper's long-standing research interests are in the fields of oxidative stress, brain aging and neurodegenerative diseases. Three papers (1980-3) emanating from his doctoral thesis provided the earliest published evidence that chronic exposure to ovarian estrogen promotes aging-related degenerative changes in rodent brain regions implicated in reproductive senescence and the development of polycystic ovaries. Since 1990, his laboratory has contributed a large body of evidence and novel theory concerning the role of heme oxygenase-1 (HO-1) and iron-containing astroglia in CNS senescence and free radical-related neurodegenerative disorders. A major research focus of his laboratory is the development of blood-based biological markers for the early diagnosis and prognosis of sporadic Alzheimer disease and other degenerative human CNS afflictions. Dr. Schipper's laboratory has received generous support from the Canadian Institutes for Health Research, the Fonds de la recherche en santé du Québec and several other Canadian and American funding agencies. Dr. Schipper has published over 170 articles on various aspects of the redox neurosciences and related topics in peer-reviewed journals and is an inventor on twelve patents. In 1998, he edited the first book of its genre, entitled Astrocytes in Brain Aging and Neurodegeneration (RG Landes Co.). He co-edited a volume for the Annals of the New York Academy of Sciences on brain metals in 2004, and recently co-edited a 3-volume text entitled Principles of Free Radical Biomedicine (2012). He served on the Editorial Board of the Journal of Neurochemistry and is a member of numerous professional societies. He has given over 130 invited lectures, seminars, and presentations in Canada, the United States, Europe, and Israel. At McGill University and the Jewish General Hospital, Dr. Schipper provides basic and clinical teaching in the neurosciences and coordinates an interdisciplinary course on Free Radical Biomedicine in the Faculty of Science."
      ],
      Academics: [
        "Education:",
        "Undergraduate: McGill University, B.Sc. with Great Distinction in Biology, 1976",
        "Medical: McGill University, M.D., C.M., 1982",
        "Graduate: McGill University, Ph.D. in Neuroendocrinology (Division of Experimental Medicine), 1982",
        "Thesis Title: \"Pathologic effects of estradiol on the hypothalamic arcuate nucleus\"",
        "Supervisor: James R. Brawer, Ph.D.",
        "",
        "Post-graduate Training:",
        "Medical Internship, Internal Medicine, McGill University, Sir Mortimer B. Davis – Jewish General Hospital, 1982-1983",
        "Resident II, Internal Medicine, McGill University, Sir Mortimer B. Davis – Jewish General Hospital, 1983-1984",
        "Resident in Neurology, Neurological Institute of New York, Columbia University College of Physicians and Surgeons, 1984-1987",
        "Fellow in Endocrinology, New England Medical Center, Department of Medicine, Tufts University, 1987-1988",
        "",
        "Appointments:",
        "Assistant Professor, Department of Neurology and Neurosurgery, McGill University, 1988-1996",
        "Attending Staff in Neurology (GFT-H), Sir Mortimer B. Davis – Jewish General Hospital, 1988-1991",
        "Attending Staff in Neurology (GFT-U), Sir Mortimer B. Davis – Jewish General Hospital, 1991-present",
        "Project Director, Bloomfield Centre for Research in Aging, Lady Davis Institute for Medical Research, Sir Mortimer B. Davis – Jewish General Hospital, 1988-present",
        "Consultant Neurologist, St. Mary's Hospital, Centre for Studies in Aging, Faculty of Medicine, 1988-2007",
        "Assistant Professor, Division of Geriatric Medicine, Department of Medicine, McGill University, 1990-1996",
        "Assistant Professor, Department of Neurology & Neurosurgery and Department of Medicine and Centre for Studies in Aging, McGill University, 1994-1996",
        "Associate Professor with tenure, McGill University, 1996-2002",
        "Associate Member of Neurology Staff, Montreal Neurological Hospital, 1998-present",
        "Consultant Neurologist, Maimonides Hospital Geriatric Centre, 2000-2013",
        "Director, Centre for Neurotranslational Research, S.M.B.D.-Jewish General Hospital, 2001-2009",
        "Full Professor (tenured), Department of Neurology & Neurosurgery and Department of Medicine and Centre for Studies in Aging, McGill University, 2002-present"
      ],
      publicationsFullListUrl: "https://scholar.google.com/citations?user=ce4AGfUAAAAJ&hl=en",
      publicationsFullListText: "Google Scholar",
      publications: [],
      awards: [
        "Awards and Scholarships:",
        "Medical Research Council Bursary – Ph.D. Program, 1977-1979",
        "J.W. McConnell Award – M.D.C.M. Program, 1978-1979",
        "Medical Research Council Award – M.D.C.M. Program, 1979",
        "McConnell Memorial Fellowship – Ph.D. Program, 1979-1982",
        "Fonds de la Recherche en Santé du Québec (FRSQ) Chercheur Boursier Junior 1 (Priorité), 1991-1994 – \"Role of peroxidase-positive astrocytes in free radical-related neurodegeneration\"",
        "Fonds de la Recherche en Santé du Québec (FRSQ) Chercheur Boursier Junior 2, 1994-1999 – \"A model for the biogenesis of redox-active astrocyte granules in the aging nervous system\"",
        "Fonds de la Recherche en Santé du Québec (FRSQ) Chercheur Boursier Senior, 1999-2003 – \"Mechanisms of pathological brain iron deposition in Parkinson disease\"",
        "BIOQuebec Genesis Technology Transfer Award to Molecular Biometrics Inc., 2009",
        "Frost & Sullivan North American Technology Innovation Award to Molecular Biometrics Inc. in the field of Applied Metabolomic Analytics, 2010",
        "",
        "Other Distinctions:",
        "Distinction List of Biology Undergraduates – B.Sc. Program, 1974",
        "University Scholar – M.D.C.M. Program, 1979-1980",
        "Faculty Scholar – M.D.C.M. Program, 1980-1981",
        "Dean's Honour List – Ph.D. Program, 1982",
        "Scored in the 99th percentile on the neurology part of the American Boards Examinations in Psychiatry and Neurology, 1987",
        "1st Prize – Canadian Urological Association Essay Contest, 1994",
        "Jean-Paul Ginese Prize – VI World Meeting on Impotence, Singapore, 1994",
        "Irving and Rona Levi Foundation Prize – Best Scientific Presentation, McGill Division of Geriatric Medicine Research Day, 1997",
        "Best Poster Presentation – Division of Geriatric Medicine Research Day, McGill University, 1998",
        "Best Poster Presentation – Conseil Professionnel, Association Diabète Québec, 1998",
        "Challenge '99 Summer Student Award, Human Resources Development Canada, 1999",
        "Maureen Fuller Memorial Lecturer, University of Saskatchewan, 1999",
        "Challenge 2001 Summer Student Award, Human Resources Development Canada, 2001",
        "Best Scientific Presentation – FRSQ/McGill Division of Geriatrics Annual Research Day, 2002",
        "Challenge 2002 Summer Student Award, Human Resources Development Canada, 2002",
        "Best Clinical Presentation – 25th Annual McGill Ophthalmology Clinical and Scientific Research Day, 2002",
        "Best Clinical Presentation – 27th Annual McGill Ophthalmology Clinical and Scientific Research Day, 2004",
        "CIHR Health Professional Student Bursary (Sagi Kaduri), 2006",
        "Dr. Clarke K. McLeod Memorial Scholarship (Sagi Kaduri), 2006",
        "Fellow of the American Academy of Neurology, 2009",
        "Hinman Prize for best poster presentation, Dentistry Research Day, McGill University, 2010",
        "LDI Paper-of-the-Month, 2012",
        "Hinman Prize for best poster presentation, McGill University Faculty of Dentistry Student's Table Clinics Day, 2013",
        "Selected advance in neurologic diseases through basic science, highlighted by the American Academy of Neurology, 65th AAN Annual Meeting, 2013",
        "Special recognition – 3rd World Parkinson Congress, Montreal, 2013"
      ]
    }
  },
  {
    name: "Charles Liu, M.D., Ph.D.",
    title: "Scientific Advisor",
    image: "/liu2.jpeg",
    shortBio: "USC Professor of Neurosurgery and Neurology, USC Center for Neurorestoration Director, and USC Epilepsy Program Surgical Director",
    useTabs: true,
    tabs: {
      overview: [
        "Dr. Charles Liu completed his undergraduate education in Chemical Engineering at the University of Michigan, Ann Arbor, and went on to receive his PhD in Chemical/Biomedical Engineering at Rice University. He then attended the Yale University School of Medicine, receiving his MD degree. He trained in neurosurgery at the University of Southern California Affiliated Hospitals.",
        "He is presently a professor of neurosurgery and neurology and holds the Apuzzo Professorship for Advanced Neurosurgery. Dr. Liu is also Director of the USC Center for Neurorestoration, which functions to bring scientific advances in the laboratory and engineers new tools to restore function to the injured and diseased nervous system. In addition, he serves as the Surgical Director of the USC Comprehensive Epilepsy Program, one of the premier and highest volume surgical epilepsy programs in the world.",
        "Dr. Liu has received numerous research awards and made a large number of visitorships/invited lectures throughout the world. He serves as Associate Editor of the journal, WORLD NEUROSURGERY and the principal neurosurgical consultant for the NCAA USC Trojans Athletics Department. He is also a member of the Executive Committee of the Congress of Neurological Surgeons. At Rancho los Amigos, Dr. Liu is Chair of the Department of Neurosurgery and is developing cutting-edge programs in restorative neurosurgery, collaborating with scientists at Caltech and USC, among others."
      ],
      Academics: [
        "Education:",
        "Yale University School of Medicine, MD, 1996",
        "Internships: LAC+USC Medical Center, 1996 - 1997",
        "Residencies: LAC+USC Medical Center, 1997 - 2003",
        "Fellowships: LAC+USC Medical Center",
        "",
        "Professional Society Memberships:",
        "Congress of Neurological Surgeon",
        "American Association of Neurological Surgeons",
        "Society of University Neurosurgeons",
        "Neurosurgical Society of America",
        "Pituitary Society",
        "American Institute of Chemical Engineers Professional Society",
        "American Chemical Society",
        "American Epilepsy Society",
        "American Society of Functional and Stereotactic Neurosurgery",
        "Academy of Neurosurgery"
      ],
      publicationsFullListUrl: "https://keck.usc.edu/faculty-search/charles-liu/#chapter=chapter3",
      publicationsLinks: [
        { text: "The challenges in establishing and Upholding an adult Level III epilepsy center in an underserved area in the United states. Epilepsy Behav Rep, 2025; 31: 100779.", url: "https://pubmed.ncbi.nlm.nih.gov/?term=The%20challenges%20in%20establishing%20and%20Upholding%20an%20adult%20Level%20III%20epilepsy%20center%20in%20an%20underserved%20area%20in%20the%20United%20states" },
        { text: "Directional hand movement can be classified from insular cortex SEEG signals using recurrent neural networks and high-gamma band features. Sci Rep, 2025; 15(1): 29993.", url: "https://pubmed.ncbi.nlm.nih.gov/40819020/" },
        { text: "Human spinal cord activation during filling and emptying of the bladder. Nat Commun, 2025; 16(1): 6506.", url: "https://pubmed.ncbi.nlm.nih.gov/40664673/" },
        { text: "Beta-band power modulation in the human amygdala during a Direct Reach arm reaching task. Neurosci Res, 2025; 216: 104906.", url: "https://pubmed.ncbi.nlm.nih.gov/40360082/" },
        { text: "Neural Mechanisms of Poststroke Urinary Incontinence: Results From an fMRI Study. Stroke, 2025; 56(6): 1516-1527.", url: "https://pubmed.ncbi.nlm.nih.gov/40207355/" },
        { text: "Cervical spinal cord stimulation for treatment of upper limb paralysis: a narrative review. J Hand Surg Eur Vol, 2025; 50(6): 781-795.", url: "https://pubmed.ncbi.nlm.nih.gov/39932700/" },
        { text: "Quantifying physical degradation alongside recording and stimulation performance of 980 intracortical microelectrodes chronically implanted in three humans for 956-2130 days. Acta Biomater, 2025; 198: 188-206.", url: "https://pubmed.ncbi.nlm.nih.gov/40037510/" },
        { text: "Beta-band power modulation in the human amygdala during a delayed reach task. J Clin Neurosci, 2025; 135: 111151.", url: "https://pubmed.ncbi.nlm.nih.gov/40020562/" },
        { text: "Human adult neurogenesis loss corresponds with cognitive decline during epilepsy progression. Cell Stem Cell, 2025; 32(2): 293-301.e3.", url: "https://pubmed.ncbi.nlm.nih.gov/39642885/" },
        { text: "Correlating stroke risk with non-invasive cerebrovascular perfusion dynamics using a portable speckle contrast optical spectroscopy laser device. Biomed Opt Express, 2024; 15(10): 6083-6097.", url: "https://pubmed.ncbi.nlm.nih.gov/39421763/" },
        { text: "Understanding the human conflict processing network: A review of the literature on direct neural recordings during performance of a modified stroop task. Neurosci Res, 2024; 206: 1-19.", url: "https://pubmed.ncbi.nlm.nih.gov/38582242/" },
        { text: "Beta-band power classification of go/no-go arm-reaching responses in the human hippocampus. J Neural Eng, 2024; 21(4).", url: "https://pubmed.ncbi.nlm.nih.gov/38914073/" },
        { text: "Primary somatosensory cortex organization for engineering artificial somatosensation. Neurosci Res, 2024; 204: 1-13.", url: "https://pubmed.ncbi.nlm.nih.gov/38278220/" },
        { text: "Functional ultrasound imaging of the human spinal cord. Neuron, 2024; 112(10): 1710-1722.e3.", url: "https://pubmed.ncbi.nlm.nih.gov/41723929/" },
        { text: "Neuromodulation of Eating Disorders: A Review of Underlying Neural Network Activity and Neuromodulatory Treatments. Brain Sci, 2024; 14(3).", url: "https://pubmed.ncbi.nlm.nih.gov/38539589/" },
        { text: "A Pilot Study of the Effect of Transcutaneous Spinal Cord Stimulation on Micturition-Related Brain Activity and Lower Urinary Tract Symptoms After Stroke. J Urol, 2024; 211(2): 294-304.", url: "https://pubmed.ncbi.nlm.nih.gov/37930962/" },
        { text: "Neurotropism of SARS-CoV-2: A Pathological Examination of Neurosurgical Specimens. Neurosurgery, 2024; 94(2): 379-388.", url: "https://pubmed.ncbi.nlm.nih.gov/37728367/" },
        { text: "Cognitive outcomes after magnetic resonance-guided laser interstitial thermal therapy for mesial temporal lobe epilepsy in adolescent patients. Epilepsy Behav Rep, 2024; 28: 100723.", url: "https://pubmed.ncbi.nlm.nih.gov/39555496/" },
        { text: "Stereotactic Frame-Based Electrode Insertion: The Accuracy of Increasingly Oblique Insertion Angles. Turk Neurosurg, 2024; 34(1): 128-134.", url: "https://pubmed.ncbi.nlm.nih.gov/38282591/" },
        { text: "Suppression of cortical electrostimulation artifacts using pre-whitening and null projection. J Neural Eng, 2023; 20(5).", url: "https://pubmed.ncbi.nlm.nih.gov/37666246/" },
        { text: "Electric Field Navigated 1-Hz rTMS for Poststroke Motor Recovery: The E-FIT Randomized Controlled Trial. Stroke, 2023; 54(9): 2254-2264.", url: "https://pubmed.ncbi.nlm.nih.gov/37577801/" },
        { text: "A review of neurophysiological effects and efficiency of waveform parameters in deep brain stimulation. Clin Neurophysiol, 2023; 152: 93-111.", url: "https://pubmed.ncbi.nlm.nih.gov/37208270/" },
        { text: "A C-shaped miniaturized coil for transcranial magnetic stimulation in rodents. J Neural Eng, 2023; 20(2).", url: "https://pubmed.ncbi.nlm.nih.gov/36863013/" },
        { text: "Zinc deficiency impairs axonal regeneration and functional recovery after spinal cord injury by modulating macrophage polarization via NF-κB pathway. Front Immunol, 2023; 14: 1290100.", url: "https://pubmed.ncbi.nlm.nih.gov/38022538/" },
        { text: "Vagus nerve stimulation paired with rehabilitation for stroke: Implantation experience from the VNS-REHAB trial. J Clin Neurosci, 2022; 105: 122-128.", url: "https://pubmed.ncbi.nlm.nih.gov/36182812/" },
        { text: "Tissue Expanders in Staged Calvarial Reconstruction: A Systematic Review. Arch Plast Surg, 2022; 49(6): 729-739.", url: "https://pubmed.ncbi.nlm.nih.gov/36523916/" },
        { text: "Ten-year safety of pluripotent stem cell transplantation in acute thoracic spinal cord injury. J Neurosurg Spine, 2022; 37(3): 321-330.", url: "https://pubmed.ncbi.nlm.nih.gov/35364569/" },
        { text: "Frequency-specific medial septal nucleus deep brain stimulation improves spatial memory in MK-801-treated male rats. Neurobiol Dis, 2022; 170: 105756.", url: "https://pubmed.ncbi.nlm.nih.gov/35584727/" },
        { text: "Baseline hippocampal beta band power is lower in the presence of movement uncertainty. J Neural Eng, 2022; 19(4).", url: "https://pubmed.ncbi.nlm.nih.gov/35803209/" },
        { text: "Massively parallel functional photoacoustic computed tomography of the human brain. Nat Biomed Eng, 2022; 6(5): 584-592.", url: "https://pubmed.ncbi.nlm.nih.gov/34059809/" },
        { text: "Altered adult neurogenesis and gliogenesis in patients with mesial temporal lobe epilepsy. Nat Neurosci, 2022; 25(4): 493-503.", url: "https://pubmed.ncbi.nlm.nih.gov/35383330/" },
        { text: "Theta low-gamma phase amplitude coupling in the human orbitofrontal cortex increases during a conflict-processing task. J Neural Eng, 2022; 19(1).", url: "https://pubmed.ncbi.nlm.nih.gov/35086075/" },
        { text: "Neuromodulation in Beta-Band Power Between Movement Execution and Inhibition in the Human Hippocampus. Neuromodulation, 2022; 25(2): 232-244.", url: "https://pubmed.ncbi.nlm.nih.gov/35125142/" },
        { text: "Artifact propagation in subdural cortical electrostimulation: Characterization and modeling. Front Neurosci, 2022; 16: 1021097.", url: "https://pubmed.ncbi.nlm.nih.gov/36312030/" },
        { text: "Subthreshold repetitive transcranial magnetic stimulation suppresses ketamine-induced poly population spikes in rat sensorimotor cortex. Front Neurosci, 2022; 16: 998704.", url: "https://pubmed.ncbi.nlm.nih.gov/36340783/" },
        { text: "Low Intensity Repetitive Transcranial Magnetic Stimulation Modulates Spontaneous Spiking Activities in Rat Cortex. Annu Int Conf IEEE Eng Med Biol Soc, 2021; 2021: 6318-6321.", url: "https://pubmed.ncbi.nlm.nih.gov/34892558/" },
        { text: "Safety of direct injection of oligodendrocyte progenitor cells into the spinal cord of uninjured Göttingen minipigs. J Neurosurg Spine, 2021; 35(3): 389-397.", url: "https://pubmed.ncbi.nlm.nih.gov/34243160/" },
        { text: "Amygdaloid theta-band power increases during conflict processing in humans. J Clin Neurosci, 2021; 91: 183-192.", url: "https://pubmed.ncbi.nlm.nih.gov/34373025/" },
        { text: "Hippocampal and Orbitofrontal Theta Band Coherence Diminishes During Conflict Resolution. World Neurosurg, 2021; 152: e32-e44.", url: "https://pubmed.ncbi.nlm.nih.gov/33872837/" },
        { text: "Gray Matter Atrophy: The Impacts of Resective Surgery and Vagus Nerve Stimulation in Drug-Resistant Epilepsy. World Neurosurg, 2021; 149: e535-e545.", url: "https://pubmed.ncbi.nlm.nih.gov/33549931/" },
        { text: "Vagus nerve stimulation paired with rehabilitation for upper limb motor function after ischaemic stroke (VNS-REHAB): a randomised, blinded, pivotal, device trial. Lancet, 2021; 397(10284): 1545-1553.", url: "https://pubmed.ncbi.nlm.nih.gov/41834814/" },
        { text: "Mapping of primary somatosensory cortex of the hand area using a high-density electrocorticography grid for closed-loop brain computer interface. J Neural Eng, 2021; 18(3).", url: "https://pubmed.ncbi.nlm.nih.gov/32131064/" },
        { text: "Cognitive effects of theta frequency bilateral subthalamic nucleus stimulation in Parkinson's disease: A pilot study. Brain Stimul, 2021; 14(2): 230-240.", url: "https://pubmed.ncbi.nlm.nih.gov/33418095/" },
        { text: "A sparse multiscale nonlinear autoregressive model for seizure prediction. J Neural Eng, 2021; 18(2).", url: "https://pubmed.ncbi.nlm.nih.gov/33470981/" },
        { text: "Deep Brain Stimulation for Alzheimer's Disease: Tackling Circuit Dysfunction. Neuromodulation, 2021; 24(2): 171-186.", url: "https://pubmed.ncbi.nlm.nih.gov/34677876/" },
        { text: "The human primary somatosensory cortex encodes imagined movement in the absence of sensory information. Commun Biol, 2020; 3(1): 757.", url: "https://pubmed.ncbi.nlm.nih.gov/33311578/" },
        { text: "The effect of stroke on micturition associated brain activity: A pilot fMRI study. Neurourol Urodyn, 2020; 39(8): 2198-2205.", url: "https://pubmed.ncbi.nlm.nih.gov/32761953/" },
        { text: "Nine-year prospective efficacy and safety of brain-responsive neurostimulation for focal epilepsy. Neurology, 2020; 95(9): e1244-e1256.", url: "https://pubmed.ncbi.nlm.nih.gov/32690786/" },
        { text: "Prospects of Photo- and Thermoacoustic Imaging in Neurosurgery. Neurosurgery, 2020; 87(1): 11-24.", url: "https://pubmed.ncbi.nlm.nih.gov/31620798/" },
        { text: "Gamma-band modulation in the human amygdala during reaching movements. Neurosurg Focus, 2020; 49(1): E4.", url: "https://pubmed.ncbi.nlm.nih.gov/32610288/" },
        { text: "Comparison of Intraoperative 3-Dimensional Fluoroscopy With Standard Computed Tomography for Stereotactic Frame Registration. Oper Neurosurg (Hagerstown), 2020; 18(6): 698-709.", url: "https://pubmed.ncbi.nlm.nih.gov/31848611/" },
        { text: "Utility and lower limits of frequency detection in surface electrode stimulation for somatosensory brain-computer interface in humans. Neurosurg Focus, 2020; 48(2): E2.", url: "https://pubmed.ncbi.nlm.nih.gov/32006952/" },
        { text: "Dual responsive neurostimulation implants for epilepsy. J Neurosurg, 2020; 132(1): 225-231.", url: "https://pubmed.ncbi.nlm.nih.gov/40053878/" }
      ],
      publications: [],
      awards: [
        "2015 and 2011 list of America's Top Doctors, compiled by Castle Connolly Medical Ltd.",
        "CNS Margot Anderson Foundation Fellowship for Brain Restoration Research, Congress of Neurological Surgeons, 2002",
        "Baxter Scholar, University of Southern California Keck School of Medicine, 2003",
        "AANS Young Clinician Investigator Award, American Association of Neurological Surgeons, 2004",
        "Honorary Member, Hong Kong Neurosurgical Society, 2005-present",
        "Anspach Research Award for Cerebrovascular Diseases and Cerebral Protection, 2006",
        "Honorary Member, Chinese Neurosurgical Society, 2008-present",
        "Michael L. J. Apuzzo Professorship for Advanced Neurosurgery, Keck School of Medicine of USC, 2009-present"
      ]
    }
  },
  {
    name: "Jianzhong J. Zhang M.D., Ph.D.",
    title: "Advisor",
    image: "/zhang.jpg",
    shortBio: "Chief Aerospace Medicine Service at United States Air Force",
    useTabs: true,
    tabs: {
      overviewLinks: [
        { text: "Federal Aviation Administration Regional Flight Surgeon", url: "https://www.faa.gov/pilots/medical_certification/rfs" }
      ],
      overview: [
        "Dr. Jianzhong J. Zhang is recently retired as the Chief of Aerospace Medicine at Offutt Air Force Base, Omaha, NE. During his military service, he oversees the execution of Aerospace Medicine Enterprise and provides expertise as a consultant to the commanders. He is directly involved in medical care and operational support in garrison as well as while deployed. He served as the installation Environmental and Occupational Health consultant, protecting our airmen's health and ensuring safety.",
        "Dr. Zhang came to the University of California at Los Angeles from Beijing, where he finished medical school. At UCLA, he majored in Public Health and received his PhD. He received further training as a postdoctoral fellow in molecular and biology lab to identify the carcinogenesis process of benzo(a)pyrene, a known incomplete products of fuel combustion.",
        "After his training in Nuclear Medicine residency at Greater VA West Los Angeles Healthcare System, Jianzhong joined the military service with his first station at Lackland AFB. He provided diagnostic and therapeutic nuclear medicine services to the 59th Medical Wing and Tricare beneficiaries. He then retrained as a flight surgeon at Edwards AFB, CA, where he participated with a medical team and flawlessly recovered Space Shuttle Atlantis (NASA mission STS-117), during a weather divert in June 2007.",
        "As flight surgeon, he deployed six times and logged in 1,193 flying hours, including about 200 combat hours. He proudly flies in the F-16, T-38, C-5, C-17, C-130 and KC-135. His most memorable station is the Joint Base Langley-Eustice where he enjoyed multiple sorties with the fighter squadrons.",
        "He currently works as a flight surgeon in eastern region for the Federal Aviation Administration."
      ],
      Academics: [
        "Education:",
        "MD, Medical School, Beijing",
        "PhD, Public Health, University of California, Los Angeles (UCLA)",
        "",
        "Postdoctoral Training:",
        "Postdoctoral Fellow, Molecular Biology Laboratory, UCLA - Research focused on identifying the carcinogenesis process of benzo(a)pyrene, a known incomplete product of fuel combustion",
        "Nuclear Medicine Residency, Greater VA West Los Angeles Healthcare System",
        "",
        "Military Training:",
        "Flight Surgeon Training, Edwards AFB, California"
      ],
      research: [
        "Research focused on identifying the carcinogenesis process of benzo(a)pyrene, a known incomplete product of fuel combustion.",
        "Aerospace medicine and flight physiology.",
        "Environmental and occupational health in military settings."
      ],
      publicationsLinks: [
        { text: "Joe X Zhang, Jianzhong J Zhang, Case Report of Improvement in Long-COVID Symptoms in an Air Force Medic Treated With Transcranial Magnetic Stimulation Using Electro-Magnetic Brain Pulse Technique, Military Medicine, Volume 188, Issue 11-12, November/December 2023, Pages e3711–e3715,", url: "https://doi.org/10.1093/milmed/usad182", linkText: "https://doi.org/10.1093/milmed/usad182" }
      ],
      publications: [],
      highlights: [
        "Chief of Aerospace Medicine, Offutt Air Force Base, Omaha, NE",
        "Participated in medical team that flawlessly recovered Space Shuttle Atlantis (NASA mission STS-117) during weather divert, June 2007",
        "Six deployments with 1,193 flying hours including approximately 200 combat hours",
        "Flight experience in F-16, T-38, C-5, C-17, C-130, and KC-135 aircraft",
        "Installation Environmental and Occupational Health Consultant"
      ],
      highlightsImage: {
        src: "/zhang2.png",
        caption: "633rd Medical Group",
        url: "https://picryl.com/media/col-jianzhong-zhang-633rd-medical-group-chief-of-ce005e?zoom=true"
      }
    }
  },
  {
    name: "Michelle A. Jilek, PT, DPT, OCS.",
    title: "Advisor",
    image: "/Jilek Photo 1.jpg",
    shortBio: "Flight Commander at the 56th Training Squadron, Luke Air Force Base",
    useTabs: true,
    tabs: {
      overviewLinks: [
        { text: "Optimizing the Human Weapon System", url: "https://www.aetc.af.mil/News/Article-Display/Article/2736700/optimizing-the-human-weapons-system/" },
        { text: "TITAN Arena Initiative", url: "https://www.luke.af.mil/News/Article-Display/Article/3775222/the-titan-arena-initiative-hpt-prioritizes-pilot-health/" },
      ],
      overviewLinksLabel: "Quick links:",
      featuredVideoEmbedUrl: "https://www.youtube.com/embed/bUvRxNe0cMo",
      overview: [
        "Michelle “Twitch” Jilek is an Orthopedic Clinical Specialist and Doctor of Physical Therapy with nearly 10 years of experience delivering high-level musculoskeletal and neurologic care across acute, inpatient, outpatient, and military operational environments. A retired United States Air Force Officer and current healthcare leader, she has built a career at the intersection of clinical excellence, performance optimization, and mission readiness. ", 

        "Most recently serving as a Commander and Aerospace Physical Therapist at Luke Air Force Base, Twitch led interdisciplinary medical teams supporting fighter squadron operations in critical, high-ops tempo settings. Major (Ret.) Jilek is the first-ever Aerospace Physical Therapist to attain aeronautical orders and achieve flying status in the history of the US Air Force. As an Active Duty Major and aircrew member supporting both training and combat missions, she specialized in the prevention and treatment of complex, high G-force spine injuries, while maintaining responsibility for clinical operations, personnel development, and readiness-focused medical decision-making for her team across the globe. ",
        
        "Dr. Jilek completed a Military Musculoskeletal Residency in Orthopedics at Fort Sam Houston and earned her Doctor of Physical Therapy from the University of New Mexico. She holds a board certification as an Orthopedic Clinical Specialist (OCS) and has advanced training in spine care, dry needling, and neuromodulation techniques including EEG, EMBP, and HiVE. Her military honors include two Meritorious Service Medals, two Air Force Commendation Medals, and recognition as Flight Commander of the Year in 2024. She has also been recognized as a Golden Alumna by the University of New Mexico School of Medicine, and is a published author in Military Medicine. ",
        
        "Dr. Jilek is widely recognized for advancing innovative models of critical medical care delivery for military pilots. She played a key role in the development and implementation of embedded physical therapy within fighter squadrons—an approach that dramatically improved access to care, accelerated return-to-duty timelines, and reduced reliance on traditional, outdated referral pathways. Her work in this space has been featured in Air Force Magazine, as well as multiple websites, podcasts, and news stations, and is permanently recorded in the history of the 1 st Fighter Wing at Langley Air Force Base. ",
        
        "In addition to her clinical and leadership roles, Dr. Jilek serves as an Adjunct Professor at Midwestern University and Grand Canyon University, where she teaches across undergraduate and doctoral programs in physical therapy and exercise science. She is committed to developing the next generation of clinicians through mentorship, curriculum development, and hands-on instruction. ",
        
        "Twitch is known for her ability to bridge the gap between healthcare and human performance, build high-functioning teams, and deliver efficient, outcomes-driven care in complex environments. She transitioned from Active Duty service in April 2026, and has continued to pursue opportunities to expand access to high-quality, performance-focused rehabilitation in civilian healthcare systems and beyond."    
      
      ],
      Academics: [
        "Education:",
        "2012 Bachelor of Arts, Exercise Physiology, Fort Lewis College, Durango, CO",
        "2012 Bachelor of Arts, Music, Fort Lewis College, Durango, CO",
        "2017 Doctor of Physical Therapy, University of New Mexico School of Medicine, Albuquerque, NM",
        "2019 Residency in Orthopedics, United States Air Force, Joint Base Langley-Eustis, VA",
        "2021 Squadron Officer School, United States Air Force, Distance Learning, Maxwell Air Force Base, AL",
        "2023 Air Command and Staff College, United States Air Force, Maxwell Air Force Base, AL",
        "2026 PhD in Health Psychology, Walden University, Distance Education (in progress)"
      ],
      awards: [
        "Major Awards and Decorations:",
        "Meritorious Service Medal x2",
        "Air Force Commendation Medal x2",
        "Air Force Meritorious Unit Award",
        "Air & Space Outstanding Unit Award",
        "",
        "Other Achievements:",
        "2019 CGO of the 4th Quarter, 149th Fighter Squadron",
        "2020 CGO of the 2nd Quarter, 633d Medical Operations Squadron",
        "2021 CGO of the 4th Quarter, 1st Operations Support Squadron",
        "2021 15th Air Force CGO Biomedical Science Corpsman of the Year",
        "2023 FGO of the 2nd Quarter, 56th Training Squadron",
        "2023 Flight Commander of the Year, 56th Fighter Wing",
        "2025 Instructor of the 3rd Quarter, 56th Training Squadron"
      ],
      assignments: [
        "Assignments:",
        "1. November 2018 - May 2020, Physical Therapy Element Chief, 633d Medical Operations Squadron, Langley AFB, VA.",
        "2. June 2020 - February 2021, Physical Therapist, 332nd Expeditionary Medical Group, Undisclosed Location.",
        "3. March 2021 - July 2022, Aerospace Physical Therapist, 1st OSS, Langley AFB, VA.",
        "4. August 2022 - Present, Human Performance Team Flight Commander, Human Performance Program Director, Aerospace Physical Therapist, 56th TRS, Luke AFB, AZ.",
        "",
        "Effective Dates of Promotion:",
        "Captain - March 18, 2017",
        "Major - May 1, 2023",
        "(Current as of March 2026)"
      ]
    }
  },
  {
    name: "Scot Prohaska",
    title: "High Performance Trainer",
    image: "/prohaska2.webp",
    shortBio: "Nationally recognized sports and performance consultant for elite athlete development",
    useTabs: true,
    tabs: {
      overview: [
        "Scot Prohaska is distinguished as a nationally recognized sports and executive performance consultant. Scot specializes in elevating performance and developing the careers of elite athletes. His blend of world-class knowledge, research, in conjunction with creative application of an artist ensures there are no \"cookie-cutter\" programs or diagnostic work for his clients.",
        "Scot carefully evaluates each client and develops a specific program to address individual needs and opportunities, which includes nutrition and lifestyle. He is at the forefront of the newest techniques and discipline, allowing all his clients to maximize their fullest potentials by giving them the tools necessary to compete at the top levels of their field. This has made him an invaluable asset to US Olympic athletes, professional athletes, student athletes, and executives.",
        "Over the past 15 years, Scot has traveled across the globe studying with leading experts in exercise physiology, kinesiology, physical therapy, biomechanics, strength, conditioning and nutrition, and mental and emotional focus and strength. He's been published in many wellness publications and is an accomplished author in the field of performance and exercise.",
        "Because of his expertise at bringing out the best in people physically, mentally and spiritually, players in the NHL, NFL, CFL and MLB consider Scot a trusted friend and part of their inner circle. Someone they are extremely comfortable referring to their fellow players and associates.",
        "Scot has also improved the performance USA and Canadian Track & Field athletes. Plus he's worked with members of USA Bobsled & Skeleton teams and with athletes who from Division I sports programs."
      ],
      links: [
        { text: "High Performance Personal Training", url: "https://www.scotprohaska.com/" },
        { text: "Procode", url: "https://procodesix.com/" }
      ]
    }
  },
  {
    name: "Srinivasa T. Reddy, Ph.D",
    title: "Scientific Advisor",
    image: "/reddy.avif",
    shortBio: "Professor of Molecular and Medical Pharmacology at UCLA, specializing in inflammatory disease research",
    useTabs: true,
    tabs: {
      overview: [
        "Dr. Srinivasa Reddy received his Bachelor's degree in Chemistry at Osmania University in Hyderabad, Telangana, India, and his Master's degree in Biological Sciences at Roorkee University in Roorkee, Uttarakhand, India. He earned his PhD in Comparative Biochemistry at the University of California, Berkeley, and became a postdoctoral scholar at the University of California, Los Angeles for Cell and Molecular Biology.",
        "He is presently a professor of Molecular and Medical Pharmacology for the Interdepartmental program of Molecular Toxicology.",
        "Dr. Reddy is primarily interested in understanding the expression, regulation, and mechanism of action of enzymes involved in arachidonic acid metabolism. He researches their role in the development of inflammatory diseases with focus on discovering diagnostic and therapeutic molecules for their treatment.",
        "Currently, his ongoing projects include:",
        "The role of cyclooxygenase 2 (COX2) in the resolution of inflammation in IBD. His laboratory was the first to report that COX2 plays an anti-inflammatory role in the mouse intestine and established a novel mouse model of Crohn's disease.",
        "The role of Paraoxonase 2 (PON2) in ischemia/reperfusion injury, heart failure, and obesity. His laboratory is conducting pioneering research on PON proteins. They have demonstrated that PON1 an HDL-associated enzyme and its cellular counterparts (PON2 and PON3) participate in the inactivation of inflammatory responses initiated by oxidized lipids.",
        "Development of apoA-I mimetic peptides for the treatment of inflammatory diseases: Over the last fifteen years, based on his work on oxidized lipids and HDL, he has developed a novel class of anti-inflammatory peptides. These agents called apoA-I mimetic peptides show promise for the treatment of inflammatory diseases. More recently, he has developed a novel therapeutic strategy by generating transgenic tomatoes expressing apoA-I mimetic peptides and is preparing to test these peptides in the clinic."
      ],
      Academics: [
        "Education:",
        "Osmania University, Hyderabad, A.P., India, B.Sc. (Hons), Chemistry, 1984",
        "Roorkee University, Roorkee, U.P. India, M.Sc. (Hons), Biological Sciences, 1986",
        "University of California, Berkeley, Ph.D., Comparative Biochemistry, 1992",
        "University of California, Los Angeles, Postdoctoral, Cell and Molecular Biology, 1997",
        "",
        "Memberships:",
        "California NanoSystems Institute",
        "Molecular Biology Institute",
        "Molecular Pharmacology GPB Home Area",
        "Molecular, Cellular & Integrative Physiology GPB Home Area",
        "Tumor Immunology Program at the Jonsson Comprehensive Cancer Center (JCCC)"
      ],
      publicationsFullListUrl: "https://scholar.google.com/citations?user=tSZF9iIAAAAJ&hl=en",
      publicationsFullListText: "Google Scholar",
      publicationsLinks: [
        { text: "A novel application of LC-MS/MS accurately quantifies the labile redox pools of cellular coenzymes Q9 and Q10. Free Radic Biol Med. 2025 Dec 01; 240:96-107.", url: "https://pubmed.ncbi.nlm.nih.gov/40812599/" },
        { text: "The intestine and cardiovascular disease. Curr Opin Lipidol. 2025 Oct 01; 36(5):221-225.", url: "https://pubmed.ncbi.nlm.nih.gov/40699207/" },
        { text: "Mechanisms and applications of apolipoproteins and apolipoprotein mimetic peptides: Common pathways in cardiovascular disease and cancer. Semin Cancer Biol. 2025 Aug; 113:74-84.", url: "https://pubmed.ncbi.nlm.nih.gov/40345461/" },
        { text: "Identifying a sepsis subphenotype characterized by dysregulated lipoprotein metabolism using a simplified clinical data algorithm. Shock. 2025 Aug 01; 64(2):218-225.", url: "https://pubmed.ncbi.nlm.nih.gov/40267485/" },
        { text: "Mass spectrometric profiling of primary estrogens and estrogen metabolites in human stool and plasma partially elucidates the role of the gut microbiome in estrogen recycling. Mol Cell Endocrinol. 2025 Jun 01; 603:112534.", url: "https://pubmed.ncbi.nlm.nih.gov/40180172/" },
        { text: "Plasma levels of adhesion molecules are elevated in dermatomyositis-interstitial lung disease and associated with low paraoxonase-1 activity. Arthritis Res Ther. 2025 Mar 08; 27(1):53.", url: "https://pubmed.ncbi.nlm.nih.gov/40055821/" },
        { text: "Prostaglandin E2 and Akt Promote Stemness in Apc Mutant Dclk1+ Cells to Give Rise to Colitis-associated Cancer. Cell Mol Gastroenterol Hepatol. 2025; 19(6):101469.", url: "https://pubmed.ncbi.nlm.nih.gov/39884575/" },
        { text: "Multiomic molecular patterns of lipid dysregulation in a subphenotype of sepsis with higher shock incidence and mortality. Crit Care. 2024 Dec 24; 28(1):431.", url: "https://pubmed.ncbi.nlm.nih.gov/39716214/" },
        { text: "Intestinal IFNα4 promotes 15-HETE diet-induced pulmonary hypertension. Respir Res. 2024 Nov 28; 25(1):419.", url: "https://pubmed.ncbi.nlm.nih.gov/39609844/" },
        { text: "Disease response in rheumatoid arthritis across four biologic therapies associates with improvement in paraoxonase-1 activity and oxylipins. RMD Open. 2024 Oct 26; 10(4).", url: "https://pubmed.ncbi.nlm.nih.gov/39461874/" },
        { text: "Evidence further linking the intestine to cardiovascular disease. Curr Opin Lipidol. 2024 Oct 01; 35(5):223-227.", url: "https://pubmed.ncbi.nlm.nih.gov/39073599/" },
        { text: "The Lipid Intensive Drug Therapy for Sepsis Phase II Pilot Clinical Trial. Crit Care Med. 2024 Aug 01; 52(8):1183-1193.", url: "https://pubmed.ncbi.nlm.nih.gov/38488429/" },
        { text: "Lipidomic changes in a novel sepsis outcome-based analysis reveals potent pro-inflammatory and pro-resolving signaling lipids. Clin Transl Sci. 2024 Mar; 17(3):e13745.", url: "https://pubmed.ncbi.nlm.nih.gov/38488489/" },
        { text: "Exercise mitigates flow recirculation and activates metabolic transducer SCD1 to catalyze vascular protective metabolites. Sci Adv. 2024 Feb 16; 10(7):eadj7481.", url: "https://pubmed.ncbi.nlm.nih.gov/38354249/" },
        { text: "Paraoxonase 2 Deficiency Causes Mitochondrial Dysfunction in Retinal Pigment Epithelial Cells and Retinal Degeneration in Mice. Antioxidants (Basel). 2023 Sep 30; 12(10).", url: "https://pubmed.ncbi.nlm.nih.gov/37891899/" },
        { text: "Lipid Mediators and Cytokines/Chemokines Display Differential Profiles in Severe versus Mild/Moderate COVID-19 Patients. Int J Mol Sci. 2023 Aug 22; 24(17).", url: "https://pubmed.ncbi.nlm.nih.gov/37685858/" },
        { text: "The multiple roles of lysophosphatidic acid in vascular disease and atherosclerosis. Curr Opin Lipidol. 2023 Oct 01; 34(5):196-200.", url: "https://pubmed.ncbi.nlm.nih.gov/37497844/" },
        { text: "DHCR7 Expression Predicts Poor Outcomes and Mortality From Sepsis. Crit Care Explor. 2023 Jun; 5(6):e0929.", url: "https://pubmed.ncbi.nlm.nih.gov/37332366/" },
        { text: "Role of enterocyte Enpp2 and autotaxin in regulating lipopolysaccharide levels, systemic inflammation, and atherosclerosis. J Lipid Res. 2023 May; 64(5):100370.", url: "https://pubmed.ncbi.nlm.nih.gov/37059333/" },
        { text: "Macrophage COX2 Mediates Efferocytosis, Resolution Reprogramming, and Intestinal Epithelial Repair. Cell Mol Gastroenterol Hepatol. 2022; 13(4):1095-1120.", url: "https://pubmed.ncbi.nlm.nih.gov/35017061/" }
      ],
      publications: []
    }
  },
  {
    name: "Fabio Macciardi, M.D., Ph.D.",
    title: "Scientific Advisor",
    image: "/macciardi.png",
    shortBio: "Research Professor of Psychiatry at USC and Professor of Molecular Psychiatry at UC Irvine",
    useTabs: true,
    tabs: {
      overview: [
        "Dr. Fabio Macciardi is presently a Research Professor of Psychiatry at USC's Keck School of Medicine, and Professor of Molecular Psychiatry at the University of California, Irvine.",
        "Dr. Macciardi is both a certified (EU) clinical psychiatrist and epidemiologist and a well-established psychiatric geneticist with years of experience in large-scale and international collaborations. He has identified PS1 the first gene for early onset Alzheimer's disease (Hyslop et al, 1992) and several genes (DAOA, DAAO, AHI1) for schizophrenia, now definitively confirmed. Most of his work has been on the genetics of complex disorders (other than AD and schizophrenia, He worked on bipolar disorders, autism, depression, autoimmune disorders and ALS) and pharmacogenomics.",
        "At present, his lab activities are mostly related to study the function and evolution of genes in complex traits and to next-generation sequencing (NGS) of complex traits. In 2010, his team published the first paper that shows the identification of a gene and its molecular defect in a rare Mendelian disorder using NGS and they are now extending this approach to find the molecular bases of genes involved in schizophrenia, autism and AD.",
        "His current major research interests are related to studying the fine mechanisms of gene regulation exerted by the non-coding DNA. All across his research, development of genetic epidemiology methods and algorithms remains a major focus of activity."
      ],
      Academics: [
        "Education:",
        "University of Milan, School of Medicine, M.D. 1975-1982",
        "University of Catania, School of Medicine, Ph.D. Psychiatric Genetics, 1983-1987",
        "Residency: University of Pavia, School of Medicine, Epidemiology and Statistics, 1987-1990",
        "Post-Doc: Yale University, School of Medicine, 1990-1991, Human Genetics",
        "",
        "Professional Society Memberships:",
        "Member of the Scientific Advisory Board for the \"Center for the Study of the genetics of complex behavior and aging\" at the S. Herzog memorial Hospital, Jerusalem, Israel",
        "Chair, Genomics Working Group, BIRN Consortium"
      ],
      awards: [
        "2000, NARSAD Independent Investigator Award",
        "1985, Italian Ministry of Education Scholarship, Human Genetics"
      ],
      publicationsFullListUrl: "https://scholar.google.com/citations?user=hzwxTkgAAAAJ&hl=en",
      publicationsFullListText: "Google Scholar",
      publications: []
    }
  }
];

const allMembers = [...teamMembers, ...advisors];

function AboutUs() {
  const particlesRef = useRef(null);
  const popupScrollRef = useRef(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedMemberIndex, setSelectedMemberIndex] = useState(null);
  const [activePopupTab, setActivePopupTab] = useState('overview');

  // Particle Flow Animation setup (same as Science page)
  useEffect(() => {
    const canvas = particlesRef.current;
    if (!canvas) return;

    const context = canvas.getContext('2d');
    let animationId;

    const deg = (a) => Math.PI / 180 * a;
    const rand = (v1, v2) => Math.floor(v1 + Math.random() * (v2 - v1));

    const opt = {
      particles: window.innerWidth / 500 ? 1000 : 500,
      noiseScale: 0.009,
      angle: Math.PI / 180 * -90,
      h1: 195,
      h2: 200,
      s1: 100,
      s2: 80,
      l1: 85,
      l2: 25,
      strokeWeight: 1.2,
      tail: 82,
    };

    const Particles = [];
    let time = 0;
    let width, height;

    function noise(x, y, z) {
      const X = Math.floor(x) & 255;
      const Y = Math.floor(y) & 255;
      const Z = Math.floor(z) & 255;
      x -= Math.floor(x);
      y -= Math.floor(y);
      z -= Math.floor(z);
      const u = fade(x);
      const v = fade(y);
      const w = fade(z);
      const A = p[X] + Y;
      const AA = p[A] + Z;
      const AB = p[A + 1] + Z;
      const B = p[X + 1] + Y;
      const BA = p[B] + Z;
      const BB = p[B + 1] + Z;
      return lerp(w, lerp(v, lerp(u, grad(p[AA], x, y, z), grad(p[BA], x - 1, y, z)), lerp(u, grad(p[AB], x, y - 1, z), grad(p[BB], x - 1, y - 1, z))), lerp(v, lerp(u, grad(p[AA + 1], x, y, z - 1), grad(p[BA + 1], x - 1, y, z - 1)), lerp(u, grad(p[AB + 1], x, y - 1, z - 1), grad(p[BB + 1], x - 1, y - 1, z - 1))));
    }

    function fade(t) { return t * t * t * (t * (t * 6 - 15) + 10); }
    function lerp(t, a, b) { return a + t * (b - a); }
    function grad(hash, x, y, z) {
      const h = hash & 15;
      const u = h < 8 ? x : y;
      const v = h < 4 ? y : h === 12 || h === 14 ? x : z;
      return ((h & 1) === 0 ? u : -u) + ((h & 2) === 0 ? v : -v);
    }

    const p = new Array(512);
    for (let i = 0; i < 256; i++) p[i] = p[i + 256] = Math.floor(Math.random() * 256);

    class Particle {
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.lx = x;
        this.ly = y;
        this.vx = 0;
        this.vy = 0;
        this.ax = 0;
        this.ay = 0;
        this.colorChoice = Math.random();
        this.setColor();
        this.maxSpeed = this.colorChoice > 0.66 ? 0.5 : this.colorChoice > 0.33 ? 1 : 0.7;
      }

      setColor() {
        if (this.colorChoice > 0.66) {
          this.hue = 195;
          this.sat = 100;
          this.light = 85;
        } else if (this.colorChoice > 0.33) {
          this.hue = 200;
          this.sat = 80;
          this.light = 25;
        } else {
          this.hue = 195;
          this.sat = 100;
          this.light = 42;
        }
      }

      randomize() {
        this.colorChoice = Math.random();
        this.setColor();
        this.maxSpeed = this.colorChoice > 0.66 ? 1.5 : this.colorChoice > 0.33 ? 1.2 : 1;
      }

      update() {
        this.follow();
        this.vx += this.ax;
        this.vy += this.ay;
        const pVal = Math.sqrt(this.vx * this.vx + this.vy * this.vy);
        const a = Math.atan2(this.vy, this.vx);
        const m = Math.min(this.maxSpeed, pVal);
        this.vx = Math.cos(a) * m;
        this.vy = Math.sin(a) * m;
        this.x += this.vx;
        this.y += this.vy;
        this.ax = 0;
        this.ay = 0;
        this.edges();
      }

      follow() {
        const angle = (noise(this.x * opt.noiseScale, this.y * opt.noiseScale, time * opt.noiseScale)) * Math.PI * 0.5 + opt.angle;
        this.ax += Math.cos(angle);
        this.ay += Math.sin(angle);
      }

      updatePrev() {
        this.lx = this.x;
        this.ly = this.y;
      }

      edges() {
        if (this.x < 0) { this.x = width; this.updatePrev(); }
        if (this.x > width) { this.x = 0; this.updatePrev(); }
        if (this.y < 0) { this.y = height; this.updatePrev(); }
        if (this.y > height) { this.y = 0; this.updatePrev(); }
      }

      render() {
        context.strokeStyle = `hsla(${this.hue}, ${this.sat}%, ${this.light}%, 0.5)`;
        context.beginPath();
        context.moveTo(this.x, this.y);
        context.lineTo(this.lx, this.ly);
        context.stroke();
        this.updatePrev();
      }
    }

    function resize() {
      width = canvas.offsetWidth;
      height = canvas.offsetHeight;
      canvas.width = width;
      canvas.height = height;
    }

    function setup() {
      resize();
      Particles.length = 0;
      for (let i = 0; i < opt.particles; i++) {
        Particles.push(new Particle(Math.random() * width, Math.random() * height));
      }
      context.lineWidth = opt.strokeWeight;
    }

    function draw() {
      time++;
      context.fillStyle = `rgba(0, 7, 15, ${(100 - opt.tail) / 100})`;
      context.fillRect(0, 0, width, height);
      for (let particle of Particles) {
        particle.update();
        particle.render();
      }
    }

    function step() {
      draw();
      animationId = requestAnimationFrame(step);
    }

    function handleClick() {
      opt.angle += deg(rand(60, 60)) * (Math.random() > 0.5 ? 1 : -1);
      for (let particle of Particles) {
        particle.randomize();
      }
    }

    setup();
    step();

    canvas.addEventListener('click', handleClick);
    window.addEventListener('resize', setup);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      canvas.removeEventListener('click', handleClick);
      window.removeEventListener('resize', setup);
    };
  }, []);

  // Animation observer
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-on-scroll');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-fade-in');
    animatedElements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Reset scroll position when a new profile is selected (for non-tabbed profiles)
  useEffect(() => {
    if (popupScrollRef.current) {
      popupScrollRef.current.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [selectedMember]);

  // Function to handle clicking on a team member card
  const handleCardClick = (member) => {
    const index = allMembers.findIndex(m => m.name === member.name);
    setSelectedMemberIndex(index);
    setSelectedMember(member);
    setActivePopupTab('overview');
    document.body.style.overflow = 'hidden';
  };
  
  // Function to navigate to next or previous team member
  const navigateTeamMember = useCallback((direction) => {
    if (selectedMemberIndex === null) return;
    
    let newIndex;
    if (direction === 'next') {
      newIndex = (selectedMemberIndex + 1) % allMembers.length;
    } else {
      newIndex = (selectedMemberIndex - 1 + allMembers.length) % allMembers.length;
    }
    
    setSelectedMemberIndex(newIndex);
    setSelectedMember(allMembers[newIndex]);
    setActivePopupTab('overview');
  }, [selectedMemberIndex]);
  
  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedMember) return;
      
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        navigateTeamMember('next');
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        navigateTeamMember('prev');
      } else if (e.key === 'Escape') {
        closePopup();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedMember, selectedMemberIndex, navigateTeamMember]);
  
  // Function to close the popup
  const closePopup = () => {
    setSelectedMember(null);
    document.body.style.overflow = 'auto'; // Re-enable scrolling
  };

  // Click outside to close
  const popupRef = useRef(null);
  const handleOutsideClick = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      closePopup();
    }
  };

  // Add touch event handling for mobile
  useEffect(() => {
    if (selectedMember) {
      const handleTouchStart = (e) => {
        if (popupRef.current && !popupRef.current.contains(e.target)) {
          closePopup();
        }
      };

      document.addEventListener('touchstart', handleTouchStart);
      return () => document.removeEventListener('touchstart', handleTouchStart);
    }
  }, [selectedMember]);

  // Add this function to force recalculation of scroll height after content is loaded
  useEffect(() => {
    const fixScrolling = () => {
      const scrollAreas = document.querySelectorAll('.popup-scroll-area');
      scrollAreas.forEach(area => {
        // Force a reflow by reading scrollHeight
        area.style.maxHeight = 'none';
        void area.scrollHeight;
        area.style.maxHeight = '70vh';
      });
    };

    // Call the function when tab is clicked
    const tabButtons = document.querySelectorAll('.tab-button');
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(fixScrolling, 100);
      });
    });

    // Call initially
    setTimeout(fixScrolling, 300);

    return () => {
      tabButtons.forEach(button => {
        button.removeEventListener('click', fixScrolling);
      });
    };
  }, [selectedMember]);

  return (
    <div className="about-us-page">
      <Helmet>
        <title>Our Team | NoetherTech</title>
      </Helmet>
      {/* Hero Section with Particles */}
      <div className="hero-section">
        <canvas ref={particlesRef} className="particles-container"></canvas>
        <div className="hero-content">
          <h1 className="animate-fade-in">OUR TEAM</h1>
          <p className="animate-fade-in delay-1 desktop-subtitle">WE INTERSECT SCIENCES WITH BRAIN HEALTH AND CARE</p>
        </div>
      </div>

      {/* Mobile Subtitle - Only visible on mobile */}
      <div className="mobile-subtitle-section">
        <p className="animate-fade-in delay-1">WE INTERSECT SCIENCES WITH BRAIN HEALTH AND CARE</p>
      </div>

      {/* Team Section */}
      <div className="team-section">
        <div className="container">
          <div className="team-profiles">
            {teamMembers.map((member, index) => (
              <div 
                key={member.name}
                className={`profile-card animate-fade-in ${index > 0 ? `delay-${index}` : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleCardClick(member);
                }}
              >
                <div className="profile-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <h3>{member.name}</h3>
                <h4>{member.title}</h4>
                <p>{member.shortBio}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Advisors Section */}
      <div className="advisors-section">
        <div className="container">
          <h2 className="section-title animate-fade-in">Advisors</h2>
          <div className="advisors-profiles">
            {advisors.map((advisor, index) => (
              <div 
                key={advisor.name}
                className={`profile-card animate-fade-in ${index > 0 ? `delay-${Math.min(index, 3)}` : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleCardClick(advisor);
                }}
              >
                <div className="profile-image">
                  <img src={advisor.image} alt={advisor.name} />
                </div>
                <h3>{advisor.name}</h3>
                <h4>{advisor.title}</h4>
                <p>{advisor.shortBio}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Team Member Popup */}
      {selectedMember && (
        <div className="popup-overlay" onClick={handleOutsideClick}>
          <div className="team-popup" ref={popupRef}>
            <button className="close-button" onClick={closePopup}>×</button>
            
            <div className="popup-content">
              <div className={`popup-media ${selectedMember.tabs?.featuredVideoEmbedUrl ? 'has-featured-video' : ''}`}>
                <div className="popup-image">
                  <img src={selectedMember.image} alt={selectedMember.name} />
                </div>
                {selectedMember.tabs?.featuredVideoEmbedUrl && (
                  <div className="popup-video">
                    <iframe
                      src={selectedMember.tabs.featuredVideoEmbedUrl}
                      title={`${selectedMember.name} video`}
                      loading="lazy"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    />
                  </div>
                )}
              </div>
              <div className="popup-details">
                <div className="popup-header">
                  <h2>{selectedMember.name}</h2>
                  <h3>{selectedMember.title}</h3>
                </div>
                
                {selectedMember.useTabs ? (
                  <TabsInterface 
                    tabs={selectedMember.tabs} 
                    activeTab={activePopupTab} 
                    setActiveTab={setActivePopupTab} 
                  />
                ) : (
                  <div className="popup-scroll-area" ref={popupScrollRef}>
                    <div className="popup-bio">
                      {selectedMember.extendedBio.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Navigation buttons now go here */}
            <div className="nav-buttons-container">
              <button 
                className="nav-button prev-button" 
                onClick={() => navigateTeamMember('prev')}
                aria-label="Previous team member"
              >
                ‹
              </button>
              <button 
                className="nav-button next-button" 
                onClick={() => navigateTeamMember('next')}
                aria-label="Next team member"
              >
                ›
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function TabsInterface({ tabs, activeTab, setActiveTab }) {
  const scrollRef = useRef(null);
  const [scrollState, setScrollState] = useState({ thumbHeight: 0, thumbTop: 0, showScrollbar: false });

  const getTabContent = () => {
    if (activeTab === 'academics' && tabs.Academics) {
      return tabs.Academics;
    }
    return tabs[activeTab];
  };

  const content = getTabContent();

  // Calculate scrollbar dimensions and position
  const updateScrollbar = useCallback(() => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      const hasOverflow = scrollHeight > clientHeight + 10;
      
      if (hasOverflow) {
        const trackHeight = clientHeight - 8; // padding
        const thumbHeight = Math.max(30, (clientHeight / scrollHeight) * trackHeight);
        const maxThumbTop = trackHeight - thumbHeight;
        const scrollRatio = scrollTop / (scrollHeight - clientHeight);
        const thumbTop = scrollRatio * maxThumbTop;
        
        setScrollState({ thumbHeight, thumbTop: thumbTop + 4, showScrollbar: true });
      } else {
        setScrollState({ thumbHeight: 0, thumbTop: 0, showScrollbar: false });
      }
    }
  }, []);

  useEffect(() => {
    const scrollEl = scrollRef.current;
    if (scrollEl) {
      scrollEl.addEventListener('scroll', updateScrollbar);
      // Initial calculation after content renders
      const timer = setTimeout(updateScrollbar, 100);
      return () => {
        scrollEl.removeEventListener('scroll', updateScrollbar);
        clearTimeout(timer);
      };
    }
  }, [updateScrollbar, activeTab, tabs]);

  // Reset scroll position when tab changes or new profile is loaded
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: 'auto' });
    }
    // Recalculate scrollbar after reset
    setTimeout(updateScrollbar, 50);
  }, [activeTab, tabs, updateScrollbar]);
  
  return (
    <div className="tabs-container">
      <div className="tabs-header">
        <button
          className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          Overview
        </button>
        {tabs.Academics && (
          <button
            className={`tab-button ${activeTab === 'academics' ? 'active' : ''}`}
            onClick={() => setActiveTab('academics')}
          >
            Education
          </button>
        )}
        {tabs.publications && (
          <button
            className={`tab-button ${activeTab === 'publications' ? 'active' : ''}`}
            onClick={() => setActiveTab('publications')}
          >
            Publications
          </button>
        )}
        {tabs.awards && (
          <button
            className={`tab-button ${activeTab === 'awards' ? 'active' : ''}`}
            onClick={() => setActiveTab('awards')}
          >
            Awards
          </button>
        )}
        {tabs.assignments && (
          <button
            className={`tab-button ${activeTab === 'assignments' ? 'active' : ''}`}
            onClick={() => setActiveTab('assignments')}
          >
            Assignments
          </button>
        )}
        {tabs.highlights && (
          <button
            className={`tab-button ${activeTab === 'highlights' ? 'active' : ''}`}
            onClick={() => setActiveTab('highlights')}
          >
            Highlights
          </button>
        )}
        {tabs.links && (
          <button
            className={`tab-button ${activeTab === 'links' ? 'active' : ''}`}
            onClick={() => setActiveTab('links')}
          >
            Links
          </button>
        )}
      </div>
      
      <div className="tab-content" ref={scrollRef}>
        <div className="popup-bio">
          {activeTab === 'overview' && tabs.overviewLinks && (
            <div className="overview-links">
              {tabs.overviewLinksLabel && <p>{tabs.overviewLinksLabel}</p>}
              {tabs.overviewLinks.map((link, index) => (
                <p key={index} className="overview-link-item">
                  <a href={link.url} target="_blank" rel="noopener noreferrer" className="bio-text-link">
                    {link.text}
                  </a>
                </p>
              ))}
            </div>
          )}
          {activeTab === 'publications' && tabs.publicationsFullListUrl && (
            <p className="publications-full-list">
              <a href={tabs.publicationsFullListUrl} target="_blank" rel="noopener noreferrer">
                {tabs.publicationsFullListText || 'See full publications list'} →
              </a>
            </p>
          )}
          {activeTab === 'publications' && tabs.publicationsLinks && (
            <div className="publications-links">
              {tabs.publicationsLinks.map((link, index) => (
                <p key={index} className="bio-content-item publication-item">
                  {link.text} <a href={link.url} target="_blank" rel="noopener noreferrer" className="pubmed-link">{link.linkText || 'View in PubMed'}</a>
                </p>
              ))}
            </div>
          )}
          {activeTab === 'links' && tabs.links && (
            <div className="links-content">
              {tabs.links.map((link, index) => (
                <p key={index}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer" className="bio-text-link">
                    {link.text}
                  </a>
                </p>
              ))}
            </div>
          )}
          {activeTab !== 'links' && content?.map((paragraph, index) => {
            if (!paragraph || paragraph.trim() === '') {
              return <div key={index} className="section-spacer" />;
            }
            const isHeader = /^(Education|Fellowships|Professional Society Memberships|Memberships|Postdoctoral Training|Post-graduate Training|Military Training|Career Highlights|Residency|Post-Doc|Internships|Residencies|Assignments|Appointments|Major Awards and Decorations|Awards and Scholarships|Other Achievements|Other Distinctions|Effective Dates of Promotion):?$/i.test(paragraph.trim());
            if (isHeader) {
              return <h4 key={index} className="bio-section-header">{paragraph.replace(/:$/, '')}</h4>;
            }
            const useSideLine = activeTab !== 'overview' && activeTab !== 'academics' && activeTab !== 'awards' && activeTab !== 'assignments';
            return <p key={index} className={useSideLine ? 'bio-content-item' : 'bio-content-plain'}>{paragraph}</p>;
          })}
          {activeTab === 'highlights' && tabs.highlightsImage && (
            <div className="highlights-image">
              <a href={tabs.highlightsImage.url} target="_blank" rel="noopener noreferrer">
                <img src={tabs.highlightsImage.src} alt={tabs.highlightsImage.caption} />
                <p className="highlights-image-caption">{tabs.highlightsImage.caption}</p>
              </a>
            </div>
          )}
        </div>
      </div>
      {/* Custom scrollbar for mobile */}
      {scrollState.showScrollbar && (
        <div className="custom-scrollbar">
          <div className="custom-scrollbar-track">
            <div 
              className="custom-scrollbar-thumb"
              style={{ 
                height: `${scrollState.thumbHeight}px`,
                transform: `translateY(${scrollState.thumbTop}px)`
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default AboutUs; 